import ApplicationController from '../application_controller'
import consumer from 'channels/consumer'

class UpdateController extends ApplicationController {
  static values = {
    'uuid': String
  }

  connect() {
    this.subscription = consumer.subscriptions.create(
      { channel: 'Events::UpdateEventChannel', uuid: this.uuidValue },
      {
        received(data) {
          this.updateEvent(data)
        },
        updateEvent(data) {
          const htmlWrapper = document.querySelector(`[data-uuid='${data.event_uuid}']`)

          if (htmlWrapper) {
            let template = document.createElement('template')
            template.innerHTML = data.html.trim()
            htmlWrapper.replaceWith(template.content.firstChild)
          }
        }
      }
    )
  }

  disconnect() {
    this.subscription.unsubscribe();
  }
}

export default UpdateController
